
import { Modal } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import Captcha from "../../../screens/BuscarInfracciones/Captcha";
import { useGeneralAppStore } from "../../../store/generalAppStore";

const ModalCaptcha = ({ datosSobre, valor, setDatosSobre, setValor, correoElectronico, setCorreoElectronico, setVerify, setErrores, errores }) => {

    //? ESTADOS GLOBALES
    const { alertasBloqueo, alertasNoBloqueo } = useActaDetalleStore();
    const { modals, handlerModal } = useGeneralAppStore()

    return (
        <>
            <Modal
                show={modals.includes('captcha')}
                size={"sm"}
                onHide={() => handlerModal({ modal: false, modalName: "captcha" })}
                title={() => ""}
            >

                <Captcha datosSobre={datosSobre} valor={valor} setDatosSobre={setDatosSobre} setValor={setValor} correoElectronico={correoElectronico} setCorreoElectronico={setCorreoElectronico} setVerify={setVerify} setErrores={setErrores} errores={errores}/>
            </Modal>
        </>
    );
}
export default ModalCaptcha;